import styled from '@emotion/styled';
import { Component } from 'react';
import { Dialog } from '../../components/dialogs/Dialog';
import { SingleColumnTable } from '../../components/table/SingleColumnTable';
import { COURSE_RECURRENCE, TRAINING_ATTRIBUTE_DIALOG_TYPE } from '../../constants';
import { withLocale, WithLocaleProps } from '../../providers/LocaleProvider';
import { KLAYO_COLORS } from '../../themes';

interface TrainingAttributesDialogProps extends WithLocaleProps {
  theme?: any;
  onClose?: () => void;
  associatedAttributeDetail?: any;
  type?: number;
  history?: any;
}

class TrainingAttributesDialogBase extends Component<TrainingAttributesDialogProps, any> {
  constructor(props: any) {
    super(props);
  }

  onAttributeSelect(e: any, attribute: any) {
    const { history } = this.props as any;
    history.push('/settings/competencies/edit/' + attribute.attributeDefinitionId);
  }

  render() {
    const { theme, onClose, associatedAttributeDetail, type, translate } = this.props;

    const dialogText =
      type === TRAINING_ATTRIBUTE_DIALOG_TYPE.DETAIL
        ? translate('dialogs.courseLinkedToCompetencies')
        : type === TRAINING_ATTRIBUTE_DIALOG_TYPE.WARNING
          ? associatedAttributeDetail.newRecurrence !== COURSE_RECURRENCE.NONE.value
            ? translate('dialogs.courseRecurrenceWarning')
            : translate('dialogs.courseNoneRecurrenceWarning')
          : '';
    const dialogTitle =
      type === TRAINING_ATTRIBUTE_DIALOG_TYPE.DETAIL
        ? translate('dialogs.linkedCompetencies')
        : type === TRAINING_ATTRIBUTE_DIALOG_TYPE.WARNING
          ? translate('dialogs.editCourseRecurrence')
          : '';
    const attributeWithoutExpiredDate = associatedAttributeDetail?.associatedAttribute.filter(
      (attribute: any) => !attribute.hasExpiryDate
    );
    const attributeWithExpiredDate = associatedAttributeDetail?.associatedAttribute.filter(
      (attribute: any) => attribute.hasExpiryDate
    );
    const attributeData =
      associatedAttributeDetail && type === TRAINING_ATTRIBUTE_DIALOG_TYPE.DETAIL
        ? associatedAttributeDetail.associatedAttribute
        : associatedAttributeDetail && type === TRAINING_ATTRIBUTE_DIALOG_TYPE.WARNING
          ? associatedAttributeDetail.newRecurrence !== COURSE_RECURRENCE.NONE.value
            ? attributeWithoutExpiredDate
            : attributeWithExpiredDate
          : null;

    return (
      <StyledTrainingAttributesDialog
        className='klayo__training-attribute-dialog'
        open={true}
        theme={theme}
        onClose={onClose}
        fullWidth
        maxWidth='sm'
        actions={[
          {
            label: translate('common.close'),
            variant: 'filled',
            onClick: onClose as any,
          },
        ]}
      >
        <h1>{dialogTitle}</h1>
        <h2>
          <span className='main-title'>{associatedAttributeDetail.name} </span>
          {dialogText}
        </h2>

        <SingleColumnTable
          showFooterRowCount={false}
          pagination={false}
          rowHasAction={true}
          minHeight='56px'
          theme={theme}
          showHeaderFromBreakpoint='md'
          showFooter={false}
          onAttributeSelect={this.onAttributeSelect.bind(this) as any}
          dense={true}
          paginationMode='client'
          columns={[
            {
              type: (SingleColumnTable as any).columns.attributes,
              label: translate('tableColumns.competencies'),
            },
          ]}
          paper={false}
          rows={attributeData ? attributeData : null}
          translate={translate}
        />
      </StyledTrainingAttributesDialog>
    );
  }
}

const StyledTrainingAttributesDialog = styled(Dialog)`
  &.klayo__training-attribute-dialog {
    h1 {
      color: ${KLAYO_COLORS.GreyGR900};
      font-family: Inter;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px; /* 133.333% */
      letter-spacing: -0.5px;
      margin-top: 0px;
      margin-bottom: 32px;
    }

    h2 {
      color: ${KLAYO_COLORS.GreyGR900};
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-top: 0px;
      margin-bottom: 24px;
    }

    .main-title {
      font-weight: 700;
    }

    .MuiDialogContent-root {
      padding: 40px 40px 0px 40px;
    }

    .MuiPaper-root {
      max-width: 640px;
    }
  }
`;

export const TrainingAttributesDialog = withLocale(TrainingAttributesDialogBase);
